import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { AppProvider } from './context/AppContext'
import { config } from './config'
import App from './App'

const msalConfig = {
  auth: {
    clientId: config?.clientId ?? '73315a8d-f440-44e9-bca9-5571a35239cb',
    authority: config?.clientAuthority ?? 'https://login.microsoftonline.com/b2eb8529-51f8-4d43-92bf-85201eea6023',
    redirectUri: config?.redirectUrl ?? 'http://localhost:3000/'
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
}

const page = {
  IncidentsPage: null,
  DraftsPage: null
}

const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Router>
    <MsalProvider instance={msalInstance}>
      <AppProvider
        apiScope={config?.apiScope ?? ''}
        apiBaseUrl={config?.apiBaseUrl ?? ''}
        page={page}
        sessionReset={false}
      >
        <App />
      </AppProvider>
    </MsalProvider>
  </Router>
)
